import { error, finish } from '../../../modules/markets/actions/settle';
import { request as refreshEvent } from '../../../modules/events/actions/get';
import api from '../../../api';

export function request(dispatch, { id, eventId }) {
    api.post(`/events/${eventId}/markets/${id}/settle`).then(
        (data) => {
            dispatch(finish(id, data));
            dispatch(refreshEvent(eventId));
        },
        (errors) => dispatch(error(id, errors))
    );
}
